var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { TextInput as RNTextInput, StyleSheet, Platform, } from 'react-native';
import { theme } from '@xbto/design-system';
import { fontMediumStyle, Row } from '../../atoms';
import { useInputFocusManager } from '../../hooks';
import { isWeb } from '../../utils';
import { FormInput } from '../form-input';
const lineHeight = theme.lineheight['lh-3'];
const hitMargin = theme.spacing['3'];
const inputHitSlop = {
    top: hitMargin,
    bottom: hitMargin,
    left: hitMargin,
    right: hitMargin,
};
export const TextInput = props => {
    const { onValueChange, validate, disabled, schema, field, label, numberOfLines = 1, rightAddOn, style } = props, rest = __rest(props, ["onValueChange", "validate", "disabled", "schema", "field", "label", "numberOfLines", "rightAddOn", "style"]);
    /**
     * Hooks
     */
    const { isFocused, onFocus, onBlur } = useInputFocusManager(props);
    /**
     * DOM
     */
    const height = rest.multiline ? lineHeight * numberOfLines : 24;
    const computedStyles = useMemo(() => {
        const styles = [$.textInput, style];
        if (isWeb) {
            styles.push({
                // @ts-expect-error - web specific property
                outline: 'none',
            });
        }
        if (height) {
            styles.push({ height });
        }
        return styles;
    }, [height, style]);
    const validation = useMemo(() => (validate && schema ? { validate, schema, field } : {}), [validate, schema, field]);
    const handleOnChange = useCallback((v) => onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(v || ''), [onValueChange]);
    return (_jsx(FormInput, Object.assign({ label: label, focused: isFocused, onChangeValue: handleOnChange, onChangePropName: "onChangeText", maxHeight: null }, validation, { children: ({ onChangeText }) => (_jsxs(Row.LR, { style: $.inputContainer, children: [_jsx(RNTextInput, Object.assign({ maxLength: 256, allowFontScaling: false, editable: !disabled, hitSlop: inputHitSlop, keyboardAppearance: "dark", numberOfLines: numberOfLines, placeholderTextColor: theme.color.text.placeholder, selectionColor: theme.color.text.primary, style: computedStyles, onChangeText: onChangeText }, rest, { onBlur: onBlur, onFocus: onFocus })), rightAddOn] })) })));
};
TextInput.displayName = 'TextInput';
const $ = StyleSheet.create({
    inputContainer: {
        flexGrow: 1,
        paddingTop: 12,
        paddingBottom: 12,
        paddingLeft: Platform.select({ web: 16, default: 0 }),
        paddingRight: Platform.select({ web: 16, default: 0 }),
    },
    textInput: Object.assign(Object.assign({}, fontMediumStyle), { fontSize: theme.fontsize.sm, lineHeight, boxSizing: 'border-box', color: theme.color.text.primary, flexGrow: 1, backgroundColor: theme.color.background.white, borderColor: 'transparent', borderRadius: Number(theme.radius.sm) }),
});
